import { Component } from '@angular/core';
import {UsuarioService} from "../../../services/usuario-service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-confirmar-email',
    templateUrl: './confirmar-email.component.html',
    styleUrl: './confirmar-email.component.css',
    standalone: false
})
export class ConfirmarEmailComponent {
  loading = true;
  tokenEmail = '';

  constructor(private usuarioService: UsuarioService,
              private route: ActivatedRoute,
              private router: Router) {
    this.route.params.subscribe(params => {
      this.tokenEmail = params['token'];
      this.confirmarEmail();
    });
  }

  private confirmarEmail(){
    this.usuarioService.confirmarEmail(this.tokenEmail).subscribe(retorno => {
      this.loading = false;
      if(retorno.sucesso){

      }
    });
  }

  public redirecionamentoSucesso(){
    this.router.navigateByUrl("");
  }
}
